import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import SaveIcon from '@mui/icons-material/Save';
import {
  Badge,
  Box,
  Button,
  Checkbox,
  Collapse,
  FormControlLabel,
  Grid,
  IconButton,
  LinearProgress,
  LinearProgressProps,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Loader from 'src/components/common/Loader';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { useGetCodeListDataQuery } from 'src/services/codeList';
import { useAppDispatch } from 'src/store';
import { hideLoader, setProgress, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppSelector } from 'src/store/hooks';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { TrainingDocUpload } from '../../documentUpload/TrainingDocUpload';
import { useDocumentUploads } from '../../documentUpload/useDocumentUploads';
import { useSiteContactInfo } from '../../steps/useSitecontactinfo';
import '../StudyLogs.scss';
import { useTrainingLogServices } from './useTrainingLogServices';
import { useTab } from 'src/components/hooks/useTab';
import { archLevel } from 'src/data/config';
import ESignConsentReAuth from 'src/components/common/ESignConsentReAuth';
import { useLazySetESignQuery } from 'src/services/ESignAPI';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { useValidUserForReAuth } from 'src/components/hooks/useValidUserForReAuth';
import { setPath } from 'src/store/Navigation';
import { setIsbacktositepersonnel } from 'src/store/SiteStudyPersonnel';

export interface ITraineeUserName {
  first_name: string;
  last_name: string;
  personnel_id: string;
  role: string;
}

export interface ICreateTraining {
  first_name: string;
  last_name: string;
  role: string;
  personnel_id: string;
  trainings: string;
  created_by: string;
}

export interface IAddDocDetails {
  document_name: string;
  document_id: string;
  tmf_level: string;
  artifact_name: string;
  type: string;
  sub_type: string;
  version_number: string;
  updated_date: string;
}
export interface IPageLevelSignInfo {
  pi_name: string | null;
  pi_signature_date_time: string | null;
  pi_signature_reason: string;
}
export interface IExpandItems {
  [key: string]: boolean;
}
const TrainingLog: React.FunctionComponent<any> = ({
  setStudyLogOpen,
  setTrainingOpen,
  openUploadDocument,
  setOpenUploadDocument,
  setForm1572Open
}) => {
  const [expandedItems, setExpandedItems] = React.useState<IExpandItems>({});
  const { isValidUserForReAuth } = useValidUserForReAuth();
  const { user } = useUser();
  const dispatchApp = useAppDispatch();
  const { checkPermission } = usePermissionWrapper();
  const { preferedDateFormat, userPreferedDateFormat, getPreferredDateTimeInLocal, getServerDateOrInvalidDayJs } =
    usePreferedDateFormat();
  const [openDilog, setOpenDilog] = React.useState(false);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [disablePageLevelSign, setDisablePageLevelSign] = useState<boolean>(true);
  const [openSignConsent, setOpenSignConsent] = useState(false);
  const [openPageSignConsent, setOpenPageSignConsent] = useState(false);
  const { selectedAppSection } = useSelectedAppInfo();
  const application = process.env.REACT_APP_NAME;
  const [logData, setLogData] = useState<any>({
    scheduled_date: null,
    completion_date: null,
    updated_by: user,
    other_trainings: '',
    file_ids: []
  });

  const [piId, setPiId] = useState('');
  const [openDilogInvestiSign, setOpenDilogInvestiSign] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [isAddButtonClicked, setIsAddButtonClicked] = useState(false);
  const { duFileUploadErrorMsg, duDocumentUploadSuccessMsg, applicationModuleSection, unSavedWarning } =
    useFieldTranslation();
  const [trainingPersonnels, setTrainingPersonnels] = useState([]);
  const [trainingLogsAPI, setTrainingLogsAPI] = useState([]);
  const isBacktoSitepersonnel = useAppSelector(state => state.siteStudyPersonnel.isBacktoSitepersonnel);
  const { setTabVal, tabsData } = useTab();
  const [traineeUserName, setTraineeUserName] = useState<ITraineeUserName>({
    first_name: '',
    last_name: '',
    personnel_id: '',
    role: ''
  });
  const [documentMetaData, setDocumentMetaData] = useState({
    name: 'Training Evidence (non study-specific)',
    number: '05.01.07'
  });
  const [pageLevelSignInfo, setPageLevelSignInfo] = useState<Partial<IPageLevelSignInfo>>({
    pi_name: null,
    pi_signature_date_time: null,
    pi_signature_reason: ''
  });
  const [openDailogPageLevelSign, setOpenDailogPageLevelSign] = useState(false);
  const {
    siteStudyPersonnelQueryData,
    siteStudyPersonnelQueryDataError,
    getSiteStudyPersonnelQueryData,
    siteTsdaStudyPersonnelQueryData,
    siteTsdaStudyPersonnelQueryDataError
  } = useSiteContactInfo();
  const { deleteAllMasterDocumentIsf } = useDocumentUploads();
  const {
    updateTrainingLog,
    getTrainingLogLoading,
    trainingLogQueryData,
    getTrainingLogError,
    getTrainingLogQueryData,
    updateTrainingLogLoading,
    getPageLevelSignData,
    updatePageLevelSignature,
    updateTrainingLogSignError,
    createTrainingLogLoading,
    createTrainingLog,
    deleteTrainingLog
  } = useTrainingLogServices();

  const [setESignature] = useLazySetESignQuery();

  const [unSavedChangesOpen, setUnSavedChangesOpen] = useState(false);

  const handleTrainingLogClose = () => {
    setStudyLogOpen(true);
    setTrainingOpen(false);
    setForm1572Open(false);
    setConfirmExitValue(dispatch, false);
  };
  const unSavedDataClosehandle = (name: string) => {
    if (name === 'move' && piId !== '') {
      setDeletePopup(true);
      setDateEnable(false);
    } else if (name === 'move' && selectedTrainingLogId !== '') {
      setOpenUploadDocument(true);
      setDateEnable(false);
    } else if (name === 'move' && isAddButtonClicked) {
      setIsAddButtonClicked(false);
      setOpenDilog(false);
      setDateEnable(false);
    } else if (name === 'move') {
      handleTrainingLogClose();
    }
    setUnSavedChangesOpen(false);
  };

  const navigateToSitInfo = () => {
    dispatch(setPath('SIVTL'));
    const currentTabinfo: any = tabsData.filter((item: any) => item.key === 'siteContactInfo');
    setTabVal(currentTabinfo[0].index);
  };

  useEffect(() => {
    return () => {
      dispatch(setIsbacktositepersonnel(false));
    };
  }, []);

  const handleUnSavedDataOpen = () => {
    if (dateEnable || selectedTrainingLogId !== '') {
      setUnSavedChangesOpen(true);
    } else if (isBacktoSitepersonnel) {
      navigateToSitInfo();
      dispatch(setIsbacktositepersonnel(false));
    } else {
      handleTrainingLogClose();
    }
  };
  /**
   * file upload
   */

  const [uploadedFile, setUploadedFile] = useState<any>([]);
  const [enable, setEnable] = useState<boolean>(false);
  const handleCloseUploadDocument = () => {
    setEnable(true);
  };
  const [selectedTrainingLogId, setselectedTrainingLogId] = useState('');

  const updateLogDocs = async (updatedDocIds: string[], isDocDelete = false) => {
    const fileData = { file_ids: updatedDocIds, updated_by: user };
    dispatch(setProgress(false));
    const updateResponse: any = await updateTrainingLog({
      id: selectedTrainingLogId,
      site_id: selectedSite,
      study_id: studyId,
      data: fileData,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME
    });
    clearData();
    getTrainingLogQueryData();
    if (updateResponse.data) {
      if (isDocDelete) {
        setPiId('');
        dispatch(setMessage({ msgDetails: 'Document Deleted successfuly', severity: 'success' }));
      } else {
        dispatch(setMessage({ msgDetails: duDocumentUploadSuccessMsg, severity: 'success' }));
      }
    }
    if (updateResponse.error && updateResponse.error.status !== 403 && updateResponse.error.status !== 401) {
      if (isDocDelete) {
        dispatch(setMessage({ msgDetails: 'Error in Document Delete', severity: 'success' }));
      } else {
        dispatch(setMessage({ msgDetails: duFileUploadErrorMsg, severity: 'error' }));
      }
      setOpenUploadDocument(false);
      clearData();
      return Promise.reject();
    }
    setselectedTrainingLogId('');
  };
  useEffect(() => {
    if (updateTrainingLogSignError) {
      dispatchApp(dispatch(setMessage({ msgDetails: 'Error signing.', severity: 'error' })));
    }
  }, [updateTrainingLogSignError]);
  const isFileUploaded = () => {
    return uploadedFile.length > 0;
  };
  const handleClosePopUp = () => {
    setEnable(false);
  };

  const handleClickAttachDoc = (recordId: string) => {
    setselectedTrainingLogId(recordId);
    if (dateEnable) {
      setUnSavedChangesOpen(true);
    } else {
      setConfirmExitValue(dispatch, false);
      setOpenUploadDocument(true);
    }
  };
  const clearData = () => {
    setUploadedFile([]);
    setEnable(false);
    setOpenUploadDocument(false);
    setselectedTrainingLogId('');
    setPiId('');
  };
  /**
   * file upload
   */
  const handleFormatDate = (value: any) => {
    return preferedDateFormat(value);
  };

  const handleDilogClose = () => {
    if (checkedCheckBoxval?.length) {
      setUnSavedChangesOpen(true);
    } else {
      setIsAddButtonClicked(false);
      setOpenDilog(false);
    }
  };
  const { data } = useGetCodeListDataQuery('SPTRNG');
  const [trainingActivities, setTrainingActivities] = useState<any>([]);
  React.useEffect(() => {
    if (data) {
      const temp = data.map((ele: any) => ele.code_list_value);
      setTrainingActivities([...temp, 'Other Activity']);
    }
  }, [data]);

  const getTLPageLevelSinatureData = async () => {
    const response: any = await getPageLevelSignData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application,
      application_module_section: applicationModuleSection.studyLogs
    });
    if (response?.isSuccess && response?.data.pi_name !== null) {
      setPageLevelSignInfo({
        pi_name: response?.data.pi_name,
        pi_signature_date_time: response?.data.pi_signature_date_time,
        pi_signature_reason: response?.data.pi_signature_reason
      });
      setDisablePageLevelSign(true);
    } else {
      setPageLevelSignInfo({
        pi_name: null,
        pi_signature_date_time: null
      });
      setDisablePageLevelSign(false);
    }
  };
  useEffect(() => {
    if (siteStudyPersonnelQueryData) {
      const personnelsToShow = siteStudyPersonnelQueryData.personnel.filter(
        (p: any) => p.site_per_startdate !== null && p.site_per_startdate !== ''
      );
      const arrOfPersonals = personnelsToShow.map((p: any, index: number) => {
        return {
          id: index,
          first_name: p.site_per_first_name,
          last_name: p.site_per_last_name,
          personnel_id: p.id,
          role: p.site_per_role
        };
      });
      setTrainingPersonnels(arrOfPersonals);
    }
    if (siteTsdaStudyPersonnelQueryData) {
      const personnelsToShow = siteTsdaStudyPersonnelQueryData.personnel.filter(
        (p: any) => p.site_per_startdate !== null && p.site_per_startdate !== ''
      );
      const arrOfPersonals = personnelsToShow.map((p: any, index: number) => {
        return {
          id: index,
          first_name: p.site_per_first_name,
          last_name: p.site_per_last_name,
          role: p.site_per_role
        };
      });
      setTrainingPersonnels(arrOfPersonals);
    }
  }, [siteStudyPersonnelQueryData, siteTsdaStudyPersonnelQueryData]);

  useEffect(() => {
    if (siteStudyPersonnelQueryDataError) {
      setTrainingPersonnels([]);
    }
    if (siteTsdaStudyPersonnelQueryDataError) {
      setTrainingPersonnels([]);
    }
  }, [siteStudyPersonnelQueryDataError, siteTsdaStudyPersonnelQueryDataError]);

  useEffect(() => {
    dispatch(showLoader());
    if (trainingLogQueryData) {
      getTLPageLevelSinatureData();
      setTrainingLogsAPI(trainingLogQueryData.Training_logs);
    }
    if (
      trainingLogQueryData &&
      trainingLogQueryData?.Training_logs &&
      trainingLogQueryData?.Training_logs.length > 0 &&
      trainingPersonnels.length > 0
    ) {
      const items: IExpandItems = {};
      trainingPersonnels.forEach((row: any) => {
        trainingLogQueryData.Training_logs.forEach((trainingLog: any) => {
          if (
            trainingLog.first_name === row.first_name &&
            trainingLog.last_name === row.last_name &&
            trainingLog.role === row.role
          ) {
            items[row.personnel_id] = true;
          }
        });
      });
      setExpandedItems(items);
    }
    dispatch(hideLoader());
  }, [trainingLogQueryData, trainingPersonnels]);

  useEffect(() => {
    if (getTrainingLogError) {
      setTrainingLogsAPI([]);
      setPageLevelSignInfo({
        pi_name: null,
        pi_signature_date_time: null
      });
    }
  }, [getTrainingLogError]);
  useEffect(() => {
    if (getTrainingLogLoading || updateTrainingLogLoading || createTrainingLogLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [getTrainingLogLoading, updateTrainingLogLoading, createTrainingLogLoading]);

  const getTrainingLogResetInfo = async () => {
    await getSiteStudyPersonnelQueryData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application,
      site_users: true,
      strictly_site_users: true
    });
    getTrainingLogQueryData();
  };
  useEffect(() => {
    getTrainingLogResetInfo();
  }, [selectedSite]);

  const piSignDisable = checkPermission('pi_sign_traininglog');
  const handleDelete = async (id: any) => {
    setPiId(id);
    if (dateEnable) {
      setUnSavedChangesOpen(true);
    } else {
      setDeletePopup(true);
      setConfirmExitValue(dispatch, false);
    }
  };
  const [dateEnable, setDateEnable] = useState(false);
  const [takeid, setTakeId] = useState('');
  const handleEdit = (item: any) => {
    setDateEnable(true);
    setLogData({
      ...logData,
      scheduled_date: item.scheduled_date,
      completion_date: item.completion_date,
      file_ids: item.file_ids
    });
    setTakeId(item.id);
    setConfirmExitValue(dispatch, true);
  };
  const handleCloseEdit = () => {
    setselectedTrainingLogId('');
    setDateEnable(false);
    setcheckedCheckBoxval([]);
    setLogData({
      scheduled_date: null,
      completion_date: null,
      updated_by: user,
      other_trainings: '',
      file_ids: []
    });
    getTrainingLogQueryData();
    setConfirmExitValue(dispatch, false);
  };
  const handleDilogSignClose = () => {
    setOpenDilogInvestiSign(false);
    setOpenDailogPageLevelSign(false);
  };
  const handleDilogInvestiSignSave = async () => {
    handleDilogSignClose();
    setOpenSignConsent(true);
  };
  const handleDilogPageLevelSignSave = async () => {
    handleDilogSignClose();
    setOpenPageSignConsent(true);
    // updateTLPageLevelSignature(user);
  };
  const handleEditSave = async (item: any, editingTrainingLog: any) => {
    if (item.scheduled_date === logData.scheduled_date && item.completion_date === logData.completion_date) {
      dispatchApp(
        dispatch(
          setMessage({ msgDetails: 'No change in data and hence cannot save the information', severity: 'error' })
        )
      );
    } else if (logData.scheduled_date === null) {
      dispatchApp(dispatch(setMessage({ msgDetails: 'Please select scheduled date', severity: 'error' })));
    } else {
      const datevalidation =
        logData.completion_date != null ? moment(logData.scheduled_date) > moment(logData.completion_date) : false;
      if (datevalidation) {
        dispatch(setMessage({ msgDetails: 'Scheduled date should be less than completion date', severity: 'error' }));
      } else {
        const checkTrainingOverlapped = editingTrainingLog.Trainings?.map((record: any) => {
          if (record.training_name === item.training_name && record.id !== item.id) {
            if (
              (moment(logData.scheduled_date) >= moment(record.scheduled_date) &&
                moment(logData.scheduled_date) <= moment(record.completion_date)) ||
              (moment(logData.completion_date) >= moment(record.scheduled_date) &&
                moment(logData.completion_date) <= moment(record.completion_date)) ||
              (moment(record.scheduled_date) >= moment(logData.scheduled_date) &&
                moment(record.scheduled_date) <= moment(logData.completion_date)) ||
              (moment(record.completion_date) >= moment(logData.scheduled_date) &&
                moment(record.completion_date) <= moment(logData.completion_date))
            ) {
              return true;
            } else {
              return false;
            }
          }
        });
        if (!checkTrainingOverlapped.includes(true)) {
          const udpatedResponse: any = await updateTrainingLog({
            site_id: selectedSite,
            study_id: studyId,
            id: item.id,
            data: logData,
            country: selectedCountry,
            application: process.env.REACT_APP_NAME
          });
          if (udpatedResponse.data) {
            setDateEnable(false);
            setLogData({ scheduled_date: null, completion_date: null, updated_by: user, file_ids: [] });
            setcheckedCheckBoxval([]);
            setselectedTrainingLogId('');
            getTrainingLogQueryData();
            dispatch(setMessage({ msgDetails: 'Data saved successfully', severity: 'success' }));
          } else if (udpatedResponse.error) {
            if (udpatedResponse.error?.status === 500 || udpatedResponse.error?.status === 404) {
              dispatch(setMessage({ msgDetails: 'Duplicate training(s) identified', severity: 'error' }));
            } else {
              dispatch(setMessage({ msgDetails: 'Error while saving data', severity: 'error' }));
            }
          }
        } else {
          dispatch(setMessage({ msgDetails: 'Trainings overlapped', severity: 'error' }));
        }
      }
    }
    setConfirmExitValue(dispatch, false);
  };
  const handlePISign = (item: any) => {
    setPiId(item.id);
    setOpenDilogInvestiSign(true);
  };

  const handlePIPageLevelSign = async () => {
    setOpenDailogPageLevelSign(true);
  };
  const dispatch = useAppDispatch();

  const [checkedCheckBoxval, setcheckedCheckBoxval] = useState([]);

  const addTrainingRecords = (trainee: any) => {
    setcheckedCheckBoxval([]);
    setIsAddButtonClicked(true);
    if (dateEnable) {
      setUnSavedChangesOpen(true);
    } else {
      setTraineeUserName({
        first_name: trainee.first_name,
        last_name: trainee.last_name,
        personnel_id: trainee.personnel_id,
        role: trainee.role
      });
      setOpenDilog(true);
    }
  };

  const handleSaveTraining = async () => {
    dispatch(showLoader());
    if (checkedCheckBoxval.length !== 0) {
      if (
        checkedCheckBoxval.find((item: any) => item.val == '99') &&
        (logData.other_trainings === '' || logData.other_trainings === null)
      ) {
        settrainingtextfilederror(true);
      } else {
        if (!checkedCheckBoxval.find((item: any) => item.val == '99')) {
          logData.other_trainings = '';
          setLogData({ ...logData, other_trainings: '' });
        }
        const numberValues: any = [];
        if (checkedCheckBoxval) {
          checkedCheckBoxval.forEach((item: any) => {
            if (item.val === '99') {
              numberValues.push(`${item.id}(${logData.other_trainings})`);
            } else {
              numberValues.push(item.id);
            }
          });
        }
        const trainingCreateObj: ICreateTraining = {
          first_name: traineeUserName.first_name,
          last_name: traineeUserName.last_name,
          role: traineeUserName.role,
          personnel_id: traineeUserName.personnel_id,
          trainings: numberValues.toString(),
          created_by: user
        };
        let isTraningExisted = false;
        if (trainingLogsAPI.length > 0) {
          trainingLogsAPI.forEach((log: any) => {
            if (
              log.first_name === trainingCreateObj.first_name &&
              log.last_name === trainingCreateObj.last_name &&
              log.role === trainingCreateObj.role
            ) {
              if (log.Trainings.length > 0) {
                log.Trainings.forEach((trng: any) => {
                  if (
                    trainingCreateObj.trainings.split(',').includes(trng.training_name) &&
                    trng.completion_date === null &&
                    trng.scheduled_date === null
                  ) {
                    isTraningExisted = true;
                  }
                });
              }
            }
          });
        }
        if (!isTraningExisted) {
          const createResponse: any = await createTrainingLog({
            site_id: selectedSite,
            study_id: studyId,
            data: trainingCreateObj,
            country: selectedCountry,
            application: process.env.REACT_APP_NAME
          });
          if (createResponse.isSuccess) {
            setExpandedItems({ ...expandedItems, [trainingCreateObj.personnel_id]: true });
            setcheckedCheckBoxval([]);
            getTrainingLogQueryData();
            setOpenDilog(false);
            setIsAddButtonClicked(false);
            dispatch(setMessage({ msgDetails: 'Training(s) saved successfully.', severity: 'success' }));
          }
        } else {
          dispatch(setMessage({ msgDetails: 'Duplicate training(s) identified', severity: 'error' }));
        }
      }
    } else {
      dispatch(setMessage({ msgDetails: 'Please select training(s)', severity: 'error' }));
    }
    dispatch(hideLoader());
  };
  const handleDeletePopupClose = () => {
    setPiId('');
    setDeletePopup(false);
  };
  const handleStudyCheckbox = (e: any, index: number) => {
    let objArr: any = checkedCheckBoxval;
    if (e.target.checked) {
      objArr.push({ id: index, val: e.target.value });
    } else {
      objArr = checkedCheckBoxval.filter((item: any) => item.val !== e.target.value);
    }
    setcheckedCheckBoxval(objArr);
  };

  const handleDeleteconfirm = async () => {
    try {
      if (piId !== '') {
        dispatch(showLoader());
        setDeletePopup(false);
        let seletedLogFileIds: any[] = [];
        if (trainingLogsAPI.length > 0) {
          trainingLogsAPI.forEach((log: any) => {
            if (log.Trainings.length > 0) {
              log.Trainings.forEach((trngs: any) => {
                if (trngs.id === piId) {
                  seletedLogFileIds = trngs.file_ids;
                  return;
                }
              });
            }
          });
        }
        if (seletedLogFileIds.length > 0) {
          await deleteAllMasterDocumentIsf({
            data: { doucment_id: seletedLogFileIds },
            study_id: studyId,
            country: selectedCountry,
            site_id: selectedSite,
            application: process.env.REACT_APP_NAME
          });
        }
        await deleteTrainingLog({
          id: piId,
          data: {
            deleted_by: user
          },
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          application: process.env.REACT_APP_NAME
        });
        dispatch(hideLoader());
        getTrainingLogQueryData();
        setPiId('');
        dispatchApp(setMessage({ msgDetails: 'Log Deleted successfully', severity: 'success' }));
      }
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else {
        dispatchApp(setMessage({ msgDetails: 'Error in Log Delete', severity: 'error' }));
      }
    }
  };

  const handleotherTainingChange = (e: any) => {
    settrainingtextfilederror(false);
    setLogData({ ...logData, other_trainings: e.target.value });
  };

  function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">{`${Math.round(props.value)}%`}</Typography>
        </Box>
      </Box>
    );
  }
  const handlePageSign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenPageSignConsent(false);

        dispatch(showLoader());
        const response: any = await updatePageLevelSignature({
          data: { pi_name: user, pi_signature_reason: data.records.sign_reason, updated_by: user },
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          username: data.records.user_name,
          password: data.records.password,
          application: process.env.REACT_APP_NAME,
          application_module_section: applicationModuleSection.studyLogs
        });
        if (response?.isSuccess && user !== null) {
          dispatch(setMessage({ msgDetails: 'PI Signed', severity: 'success' }));
        } else if (response?.isError) {
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        }
        await getTLPageLevelSinatureData();
        await getTrainingLogQueryData();
        dispatch(hideLoader());
      }
    }
  };
  const handleRowPISign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenSignConsent(false);
        dispatch(showLoader());
        const dataObj = {
          username: data.records.user_name,
          password: data.records.password,
          module_name: 'Training Log',
          name_of_signature: 'pi_name',
          name_of_date_field: 'pi_signature_date_time',
          id: piId,
          columns_to_change: {
            reason: data.records.sign_reason,
            updated_by: user
          }
        };
        const signatureResponse: any = await setESignature({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
          application_section: selectedAppSection,
          application_module_section: applicationModuleSection.studyLogs,
          data: dataObj
        });
        if (signatureResponse.isSuccess) {
          dispatchApp(setMessage({ msgDetails: 'PI Signed', severity: 'success' }));
          setOpenDilogInvestiSign(false);
          getTLPageLevelSinatureData();
          getTrainingLogQueryData();
        } else if (signatureResponse.isError) {
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        }
        dispatch(hideLoader());
      }
    }
  };
  const [trainingtextfilederror, settrainingtextfilederror] = useState(false);
  return (
    <>
      <Box mt={-1}>
        {isBacktoSitepersonnel ? (
          <Button onClick={() => handleUnSavedDataOpen()} startIcon={<ArrowBackIcon fontSize="small" />}>
            Back to site personnel details
          </Button>
        ) : (
          <Button onClick={() => handleUnSavedDataOpen()} startIcon={<ArrowBackIcon fontSize="small" />}>
            LIST OF LOGS
          </Button>
        )}
        / Training Log
      </Box>
      <Loader />
      <div className="pi-accordion study-log">
        <Grid container>
          <Grid md={12}>
            <TableContainer className="studylog-table">
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ minWidth: 110 }}>First Name</TableCell>
                    <TableCell sx={{ minWidth: 110 }}>Last Name</TableCell>
                    <TableCell sx={{ width: 70, '@media (min-width:1440px)': { minWidth: 190 } }}>Role</TableCell>
                    <TableCell colSpan={2} sx={{ minWidth: 340 }}>
                      Training Progress
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="training-table-tbody">
                  {trainingPersonnels &&
                    trainingPersonnels.map((row: any) => {
                      const itemRows: any = [];
                      let totalCompleted = 0;
                      let totalTrainings = 0;
                      let trainingProgress = 0;
                      trainingLogsAPI.forEach((trainingLog: any) => {
                        if (
                          trainingLog.first_name === row.first_name &&
                          trainingLog.last_name === row.last_name &&
                          trainingLog.role === row.role
                        ) {
                          totalCompleted = trainingLog.total_completed;
                          totalTrainings = trainingLog.total_trainings;
                          trainingProgress = trainingLog.training_progress;
                          const rowt = (
                            <>
                              {trainingLog.Trainings?.map((record: any) => {
                                let trainingName = '';
                                const priorDateTime = getPreferredDateTimeInLocal(record.pi_signature_date_time);
                                if (Object.keys(record).length > 0) {
                                  trainingActivities.map((ele: any, index: number) => {
                                    if (record.training_name.startsWith('99')) {
                                      trainingName = record.training_name.replace('99', '99 ');
                                    } else if (record.training_name === (index + 1).toString()) {
                                      trainingName = `${index + 1} ${ele}`;
                                    }
                                  });
                                  return (
                                    <TableRow
                                      key={record.id}
                                      className={dateEnable && takeid === record.id ? 'crud-row' : ''}
                                      sx={{ '& .MuiTableCell-root': { wordBreak: 'break-all' } }}
                                    >
                                      <TableCell>{trainingName}</TableCell>
                                      <TableCell>
                                        {dateEnable && takeid === record.id ? (
                                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Stack spacing={3}>
                                              <DatePicker
                                                inputFormat={userPreferedDateFormat.toUpperCase()}
                                                value={logData.scheduled_date}
                                                onChange={(newValue: any) => {
                                                  if (newValue != null) {
                                                    const changedDate = getServerDateOrInvalidDayJs(newValue);
                                                    if (changedDate !== 'Invalid Date' && changedDate.length === 10) {
                                                      setLogData({ ...logData, scheduled_date: changedDate });
                                                    }
                                                  } else {
                                                    setLogData({ ...logData, scheduled_date: null });
                                                  }
                                                }}
                                                renderInput={params => <TextField {...params} variant="standard" />}
                                              />
                                            </Stack>
                                          </LocalizationProvider>
                                        ) : (
                                          handleFormatDate(record.scheduled_date)
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        {dateEnable && takeid === record.id ? (
                                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <Stack spacing={3}>
                                              <DatePicker
                                                inputFormat={userPreferedDateFormat.toUpperCase()}
                                                value={
                                                  // endDate == null ?
                                                  logData.completion_date
                                                  // : preferedFormatForDatePicker(endDate)
                                                }
                                                onChange={(newValue: any) => {
                                                  if (newValue != null) {
                                                    const changedDate = getServerDateOrInvalidDayJs(newValue);
                                                    if (changedDate !== 'Invalid Date' && changedDate.length === 10) {
                                                      setLogData({ ...logData, completion_date: changedDate });
                                                    }
                                                  } else {
                                                    setLogData({ ...logData, completion_date: null });
                                                  }
                                                }}
                                                renderInput={params => <TextField {...params} variant="standard" />}
                                              />
                                            </Stack>
                                          </LocalizationProvider>
                                        ) : (
                                          handleFormatDate(record.completion_date)
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        {dateEnable && takeid === record.id ? null : (
                                          <>
                                            {record.pi_name !== null && record.pi_name !== '' ? (
                                              <Tooltip
                                                disableFocusListener
                                                disableTouchListener
                                                title={
                                                  <div>
                                                    Signed by {record.pi_name} on {priorDateTime}
                                                    <br />
                                                    Reason: &ldquo;{record.reason}&ldquo;
                                                  </div>
                                                }
                                              >
                                                <div>{record.pi_name}</div>
                                              </Tooltip>
                                            ) : disablePageLevelSign ? (
                                              <Button size="small" variant="contained" disabled>
                                                Sign
                                              </Button>
                                            ) : (
                                              <Button
                                                size="small"
                                                variant="contained"
                                                onClick={() => handlePISign(record)}
                                                disabled={!piSignDisable}
                                              >
                                                Sign
                                              </Button>
                                            )}
                                          </>
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        {dateEnable && takeid === record.id ? (
                                          <>
                                            <IconButton
                                              style={{ cursor: 'pointer' }}
                                              onClick={() => handleEditSave(record, trainingLog)}
                                            >
                                              {' '}
                                              <SaveIcon />
                                            </IconButton>
                                            <IconButton style={{ cursor: 'pointer' }} onClick={handleCloseEdit}>
                                              <CloseIcon />
                                            </IconButton>
                                          </>
                                        ) : (
                                          <>
                                            {disablePageLevelSign ? (
                                              <IconButton disabled>
                                                <Badge badgeContent={record.count} color="primary">
                                                  <AttachFileIcon />
                                                </Badge>
                                              </IconButton>
                                            ) : (
                                              <IconButton
                                                disabled={
                                                  pageLevelSignInfo.pi_name !== null ||
                                                  !checkPermission('view_siv_training_doc')
                                                }
                                                onClick={() => handleClickAttachDoc(record.id)}
                                              >
                                                <Badge badgeContent={record.count} color="primary">
                                                  <AttachFileIcon />
                                                </Badge>
                                              </IconButton>
                                            )}
                                            {checkPermission('update_site_siv_training') ? (
                                              disablePageLevelSign ? (
                                                <IconButton style={{ cursor: 'pointer' }} disabled>
                                                  {' '}
                                                  <EditIcon />{' '}
                                                </IconButton>
                                              ) : (
                                                <IconButton
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => handleEdit(record)}
                                                  disabled={
                                                    pageLevelSignInfo.pi_name !== null ||
                                                    !checkPermission('update_site_siv_training')
                                                  }
                                                >
                                                  {' '}
                                                  <EditIcon />{' '}
                                                </IconButton>
                                              )
                                            ) : (
                                              <></>
                                            )}
                                            {checkPermission('delete_site_siv_training') ? (
                                              disablePageLevelSign ? (
                                                <IconButton style={{ cursor: 'pointer' }} disabled>
                                                  {' '}
                                                  <DeleteIcon />
                                                </IconButton>
                                              ) : (
                                                <IconButton
                                                  style={{ cursor: 'pointer' }}
                                                  onClick={() => handleDelete(record.id)}
                                                  disabled={pageLevelSignInfo.pi_name !== null}
                                                >
                                                  {' '}
                                                  <DeleteIcon />
                                                </IconButton>
                                              )
                                            ) : null}
                                          </>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  );
                                }
                              })}
                            </>
                          );
                          itemRows.push(rowt);
                        }
                      });

                      return (
                        <>
                          <TableRow sx={{ '& > *': { borderBottom: 'unset' } }} className="category-table">
                            <TableCell component="th" scope="row">
                              {row.first_name}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {row.last_name}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {row.role}
                            </TableCell>
                            <TableCell component="th" scope="row" className="tdwithProgress">
                              <Box sx={{ display: 'flex', width: '100%' }}>
                                <Box sx={{ mr: 1 }}>{`${totalCompleted}/${totalTrainings} Complete`}</Box>
                                <LinearProgressWithLabel value={trainingProgress} />
                              </Box>
                            </TableCell>
                            <TableCell
                              component="th"
                              align="right"
                              colSpan={3}
                              className="tdwithAddBtn"
                              sx={{ minWidth: 175 }}
                            >
                              {checkPermission('update_site_siv_training') ? (
                                <Button
                                  onClick={() => addTrainingRecords(row)}
                                  disabled={pageLevelSignInfo.pi_name !== null}
                                >
                                  + Add Record
                                </Button>
                              ) : null}
                              <IconButton
                                aria-label="expand row"
                                size="small"
                                sx={{ ml: 0.5 }}
                                disabled={!itemRows.length}
                                onClick={() =>
                                  setExpandedItems({
                                    ...expandedItems,
                                    [row.personnel_id]: !expandedItems[row.personnel_id]
                                  })
                                }
                              >
                                {expandedItems[row.personnel_id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                              </IconButton>
                            </TableCell>
                          </TableRow>
                          {itemRows.length > 0 && (
                            <TableRow>
                              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                                <Collapse in={expandedItems[row.personnel_id]} timeout="auto" unmountOnExit>
                                  <Box sx={{ p: 1, background: 'rgba(0,0,0,0.04) !important' }}>
                                    <TableContainer
                                      component={Paper}
                                      sx={{
                                        boxShadow:
                                          '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12) !important'
                                      }}
                                    >
                                      <Table aria-label="Training Table">
                                        <TableHead>
                                          <TableRow>
                                            <TableCell
                                              sx={{
                                                minWidth: 300,
                                                maxWidth: '35%',
                                                fontSize: '13px !important',
                                                position: 'relative'
                                              }}
                                              className="trainingTd"
                                            >
                                              Training
                                            </TableCell>
                                            <TableCell
                                              sx={{ minWidth: 140, fontSize: '13px !important', position: 'relative' }}
                                            >
                                              Scheduled Date
                                            </TableCell>
                                            <TableCell
                                              sx={{ minWidth: 140, fontSize: '13px !important', position: 'relative' }}
                                            >
                                              Completion Date
                                            </TableCell>
                                            <TableCell
                                              sx={{ minWidth: 100, fontSize: '13px !important', position: 'relative' }}
                                            >
                                              PI Sign
                                            </TableCell>
                                            <TableCell
                                              sx={{ minWidth: 140, fontSize: '13px !important' }}
                                              className="actionTd"
                                            >
                                              Actions
                                            </TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>{itemRows}</TableBody>
                                      </Table>
                                    </TableContainer>
                                  </Box>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          )}
                        </>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Box className="Sign_aggrement_statement">
            <Grid container mt={2}>
              <Grid item md={12}>
                <Typography variant="h6" mb={1.5}>
                  Study Completion:
                </Typography>
                <Typography mb={2}>
                  I, for the protocol identified above, verify that the delegated tasks were performed under my
                  supervision.
                </Typography>
              </Grid>
              <Grid item md={12}>
                {pageLevelSignInfo.pi_name === null ? (
                  disablePageLevelSign ? (
                    <Button size="small" variant="contained" disabled sx={{ mt: 2.5 }}>
                      Sign
                    </Button>
                  ) : (
                    <Button
                      size="small"
                      variant="contained"
                      onClick={() => handlePIPageLevelSign()}
                      // disabled={!(piSignDisable && !getTrainingLogIsError)}  // Updated As per story CTMSKANBAN-7023
                      disabled
                      sx={{ mt: 2.5 }}
                    >
                      Sign
                    </Button>
                  )
                ) : (
                  <div className="signedBy">
                    Signed by <strong>{pageLevelSignInfo.pi_name}</strong> on{' '}
                    <span color="text.secondary">
                      {pageLevelSignInfo.pi_name !== null
                        ? getPreferredDateTimeInLocal(pageLevelSignInfo.pi_signature_date_time)
                        : ''}
                    </span>{' '}
                    <br />
                    <span className="signReasonrow">
                      <span color="text.secondary">Reason: </span> &ldquo;{pageLevelSignInfo.pi_signature_reason}
                      &rdquo;
                    </span>
                  </div>
                )}
              </Grid>
            </Grid>
          </Box>
        </Grid>
        <PopupComponent
          open={openDilog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <Loader />
          <DialogTitle id="alert-dialog-title">{`${traineeUserName.first_name} ${traineeUserName.last_name} Training`}</DialogTitle>
          <DialogContent className="study-activity-modal">
            <DialogContentText id="alert-dialog-description">Assign training(s) to personnel:</DialogContentText>
            <Box className="twoColText">
              {trainingActivities.map((ele: any, index: number) => {
                const found = checkedCheckBoxval.find((item: any) => item.val == index);
                const foundOther = checkedCheckBoxval.find((item: any) => item.val == '99');
                if (ele === 'Other Activity') {
                  return (
                    <FormControlLabel
                      key={99}
                      checked={foundOther}
                      control={<Checkbox value={99} onChange={(e: any) => handleStudyCheckbox(e, 99)} />}
                      label={
                        <>
                          <strong>{'99. '}</strong> <span>{ele}</span>
                          <TextField
                            value={logData.other_trainings}
                            onChange={handleotherTainingChange}
                            variant="standard"
                            error={trainingtextfilederror}
                            helperText={trainingtextfilederror ? 'required' : ''}
                            placeholder={'Specify'}
                          />
                        </>
                      }
                    />
                  );
                } else {
                  return (
                    <FormControlLabel
                      key={index}
                      checked={found}
                      control={<Checkbox value={index} onChange={(e: any) => handleStudyCheckbox(e, index + 1)} />}
                      label={
                        <>
                          <strong>{`${index + 1}. `}</strong> <span>{ele}</span>
                        </>
                      }
                    />
                  );
                }
              })}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDilogClose} className="grey-btn-link">
              Cancel
            </Button>
            <Button onClick={() => handleSaveTraining()} autoFocus>
              Save
            </Button>
          </DialogActions>
        </PopupComponent>
        <PopupComponent
          open={openDilogInvestiSign || openDailogPageLevelSign}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'Signature'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-text">
              <ol className="olinDialog">
                <li>
                  I have ensured that the individuals listed above are properly qualified and have received appropriated
                  training related to their respective tasks{' '}
                </li>
                <li>I understand that the overall responsibility for the conduct of the research remains with me</li>
              </ol>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDilogSignClose} className="grey-btn-link">
              Cancel
            </Button>
            <Button
              onClick={openDilogInvestiSign ? handleDilogInvestiSignSave : handleDilogPageLevelSignSave}
              autoFocus
            >
              Sign
            </Button>
          </DialogActions>
        </PopupComponent>
        <PopupComponent
          open={deletePopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'Delete training log?'}</DialogTitle>
          <DialogContent />
          <DialogActions>
            <Button onClick={handleDeletePopupClose}>No</Button>
            <Button onClick={handleDeleteconfirm} autoFocus>
              Yes
            </Button>
          </DialogActions>
        </PopupComponent>
      </div>
      <div>
        <PopupComponent
          onClose={() => handleCloseUploadDocument}
          aria-labelledby="customized-dialog-title"
          open={openUploadDocument}
          maxWidth="md"
        >
          <DialogContent dividers>
            <TrainingDocUpload
              documentMetaData={documentMetaData}
              setDocumentMetaData={setDocumentMetaData}
              uploadedFile={uploadedFile}
              isFileUploaded={isFileUploaded}
              setUploadedFile={setUploadedFile}
              openUploadDocument={openUploadDocument}
              setOpenUploadDocument={setOpenUploadDocument}
              clearData={clearData}
              error={null}
              trainingLogsAPI={trainingLogsAPI}
              selectedTrainingLogId={selectedTrainingLogId}
              updateLogDocs={updateLogDocs}
            />
          </DialogContent>
        </PopupComponent>
      </div>
      <PopupComponent open={enable} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{'Cancel Document Upload'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to cancel uploading this document?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={clearData} autoFocus className='grey-btn'>
            Yes
          </Button>
          <Button onClick={handleClosePopUp}>No</Button>
        </DialogActions>
      </PopupComponent>
      <PopupComponent
        open={unSavedChangesOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => unSavedDataClosehandle('stay')} className="grey-btn">
            Close
          </Button>
          <Button onClick={() => unSavedDataClosehandle('move')} autoFocus>
            Ok
          </Button>
        </DialogActions>
      </PopupComponent>
      {openSignConsent && (
        <ESignConsentReAuth
          openSignConsent={openSignConsent}
          setOpenSignConsent={setOpenSignConsent}
          handleConfirmSign={handleRowPISign}
        />
      )}
      {openPageSignConsent && (
        <ESignConsentReAuth
          openSignConsent={openPageSignConsent}
          setOpenSignConsent={setOpenPageSignConsent}
          handleConfirmSign={handlePageSign}
        />
      )}
    </>
  );
};
export default TrainingLog;
